import { useState, useEffect } from "react"
import { setBreadcrumb, setTitle } from "store/actions"
import { watchGroups, Group } from "firebase/groupsService"

export function useGroups(dispatch: any) {
	const [groups, setGroups] = useState<Group[]>([])
	const [loadingGroups, setLoadingGroups] = useState(true)
	const [groupSearch, setGroupSearch] = useState("")
	const [showArchived, setShowArchived] = useState(false)

	useEffect(() => {
		dispatch(setTitle(""))
		dispatch(setBreadcrumb(null))

		const unsub = watchGroups((grps) => {
			setGroups(grps)
			setLoadingGroups(false)
		})

		return () => unsub()
	}, [dispatch])

	const activeGroups = groups.filter((g) => g.status !== "archived")
	const archivedGroups = groups.filter((g) => g.status === "archived")

	const filteredGroups = activeGroups.filter((g) =>
		g.name.toLowerCase().includes(groupSearch.toLowerCase())
	)

	const filteredArchived = archivedGroups.filter((g) =>
		g.name.toLowerCase().includes(groupSearch.toLowerCase())
	)

	return {
		groups: activeGroups,
		archivedGroups,
		loadingGroups,
		groupSearch,
		setGroupSearch,
		filteredGroups,
		filteredArchived,
		showArchived,
		setShowArchived,
	}
}
